export default __webpack_public_path__ + "static/media/Websources_result_01.9545aa89.png";